import React from 'react';
import AdminModal from '../AdminModal';
import { useIBTranslation } from '@ibinder/ui-common-hooks';
import { CreateBrandedInviteForm } from './CreateBrandedInviteForm';

const CreateBrandedUserInviteModal = ({ onClose }) => {
  const showDoneModalNode = React.useRef();

  const { t, i18n } = useIBTranslation();

  const onCloseModal = () => {
    onClose();
  };

  return (
    <AdminModal
      loading={false}
      ref={showDoneModalNode}
      onClose={onCloseModal}
      label={t('CreateBrandedInviteHeader')}
      name={t('CreateBrandedInviteHeader')}
      Component={CreateBrandedInviteForm({
        t,
        language: i18n.language,
        onClose
      })}
    />
  );
};

export default CreateBrandedUserInviteModal;
